import { render, staticRenderFns } from "./EmptyChart.vue?vue&type=template&id=20c9f506&"
import script from "./EmptyChart.vue?vue&type=script&lang=js&"
export * from "./EmptyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports